import React, { useState, useCallback } from 'react';

export interface TooltipPosition {
  x: number;
  y: number;
}

export const useDisabledRowTooltip = (isDisabled: boolean) => {
  const [tooltipPosition, setTooltipPosition] = useState<TooltipPosition | null>(null);

  const handleMouseMove = useCallback((event: React.MouseEvent) => {
    if (isDisabled) {
      // The value `20` is used as a vertical offset to position the tooltip slightly below the mouse pointer.
      setTooltipPosition({ x: event.clientX, y: event.clientY + 20 });
    }
  }, [isDisabled]);

  const handleMouseLeave = useCallback(() => {
    if (isDisabled) {
      setTooltipPosition(null);
    }
  }, [isDisabled]);

  const hideTooltip = useCallback(() => {
    setTooltipPosition(null);
  }, []);

  return {
    tooltipPosition,
    handleMouseMove,
    handleMouseLeave,
    hideTooltip,
  };
};
